import CarouselButtons from 'components/carousel2025/CarouselButtons';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import ImageWithFallback from 'components/ImageWithFallback';
import useEmblaCarousel from 'embla-carousel-react';
import Link from 'next/link';
import styles from './PrizeCarousel.module.css';

const homepagePrizes = [
  {
    id: 1,
    title: 'Live-in camper van',
    subheading: '+ £20,000 in spending money',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/40527939-ea1f-4075-bd05-4babfe256ee4.jpg',
    slug: 'win-camper-van',
  },
  {
    id: 2,
    title: 'Win a house renovation',
    subheading: '£100K to spend on any work around the house',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/3ce6a2bb-d056-43e8-b354-981e8be0d863.jpg',
    slug: 'win-house-renovation',
  },
  {
    id: 3,
    title: '£10K Gadgets Galore',
    subheading: 'Pick n mix your favourite tech',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/885536ec-ead9-4a7b-96ef-d18dd74befd8.jpg',
    slug: 'gadgets-galore-10000',
  },
  {
    id: 4,
    title: 'Maldives for 2',
    subheading: '7 nights in paradise',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/e71af6e7-7660-4b35-89de-67545bd5f79f.jpg',
    slug: 'maldives',
  },
  {
    id: 5,
    title: 'Win a Luxury Ski Break for 10',
    subheading: 'In the 3 Valleys',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/d8a958f3-37f5-4731-abbb-81240374a600.jpg',
    slug: 'win-ski-break-for-10',
  },
  {
    id: 6,
    title: '7-nights Norwegian Fjord Cruise',
    subheading: 'Magical Norway for 2',
    heroImageLocation:
      'https://prize-assets.daymade.co.uk/e325dc24-d93d-4a9b-bb3d-e95cb0827584.jpg',
    slug: 'win-a-cruise-to-norway-fjords',
  },
]; // TODO: move this to a cms or at least a constants file. This is just placeholder data for now

export const PrizeCarousel = () => {
  const emblaCarouselInfo = useEmblaCarousel({
    loop: true,
    align: 'start',
    duration: 10,
    inViewThreshold: 0.1,
  });

  return (
    <div className={styles.carouselContainer}>
      <EmblaCarousel
        className={styles.prizeCarousel}
        emblaCarouselInfo={emblaCarouselInfo}
        items={homepagePrizes.map((recommendedPrize, index) => (
          <div key={index} className={styles.carouselSlide}>
            <Link key={index} href={`/prizes/details/${recommendedPrize.slug}`}>
              <div className={styles.carouselLinkContent}>
                <div className={styles.carouselImageWrapper}>
                  <ImageWithFallback
                    layout="fill"
                    objectFit="cover"
                    src={{
                      src: recommendedPrize.heroImageLocation,
                      width: 600,
                      height: 600,
                    }}
                    alt={recommendedPrize.title}
                    className={styles.carouselImage}
                  />
                  <div className={styles.carouselOverlay} />
                </div>
                <div className={`${styles.carouselTextContent}`}>
                  <h3 className={`aboutUsTypographyHeaderMedium textAlignLeft`}>
                    {recommendedPrize.title}
                  </h3>
                  <p className="noMargin">{recommendedPrize.subheading}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      />
      <CarouselButtons
        changeSelectedIndex={(x) =>
          x < 0
            ? emblaCarouselInfo[1]?.scrollPrev()
            : emblaCarouselInfo[1]?.scrollNext()
        }
      />
    </div>
  );
};
